var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#mail-in';
                    var viewUrl = 'svg/icons.svg#view-mail-in';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };